import { Text } from "@kanda-libs/ks-design-library";
import { capitaliseWords } from "common/helpers";
import Profile from "components/shared/Profile";
import type { FunctionComponent } from "react";
import { formatReportKey } from "./helpers";

export interface CompanyReportLineItemProps {
  reportKey: string;
  value: string;
}

const CompanyReportLineItem: FunctionComponent<CompanyReportLineItemProps> =
  function ({ reportKey, value }) {
    return (
      <Profile.Property
        label={formatReportKey(reportKey)}
        value={
          <Text
            text={capitaliseWords(value)}
            className={
              value === "PASS" || value === "FALSE"
                ? "text-green-600"
                : "text-red-200"
            }
          />
        }
      />
    );
  };

export default CompanyReportLineItem;
